<template>
  <generic-modal :title="$t('product')" :buttons="buttons" ref="generic_modal">
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="general"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="info icon" aria-hidden="true"></i>
            <span>{{ $t("general") }}</span>
          </a>
        </li>
        <li data-tab="images" @click="change_active_tab($event, this)">
          <a>
            <i class="image icon" aria-hidden="true"></i>
            <span>{{ $t("images") }}</span>
          </a>
        </li>
        <li data-tab="attributes" @click="change_active_tab($event, this)">
          <a>
            <i class="cubes icon" aria-hidden="true"></i>
            <span>{{ $t("attributes") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="general">
        <form>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("name") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.name" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("barcode") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.barcode" />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("sale price") }}</label>
                <p class="control has-icons-left">
                  <input class="input" type="text" v-model="meta.sale_price" />
                  <span class="icon is-small is-left">
                    {{ get_currency_settings().symbol }}
                  </span>
                </p>
              </div>
            </div>
            <div class="column">
              <div class="field" v-if="meta.settings">
                <label class="label">{{
                  $t("alert on inventory limit")
                }}</label>
                <p class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.settings.alert_on_inventory_limit"
                  />
                </p>
              </div>
            </div>
          </div>

          <div class="field">
            <generic-dropdown
              :title="$t('categories')"
              :placeholder="$t('select')"
              :is_multiple="true"
              url="/product/category/catalog"
              name_field="name"
              value_field="category_id"
              @change="set_category"
              ref="category_dropdown"
            />
          </div>

          <div class="title is-6 mt-5 mb-3">{{ $t("product options") }}</div>
          <div class="columns is-multiline">
            <div class="column is-5">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_product_available_for_sale"
                  v-model="meta.available_for_sale"
                />
                <label for="chk_product_available_for_sale">{{
                  $t("available for sale")
                }}</label>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_product_inventariable"
                  v-model="meta.is_inventariable"
                />
                <label for="chk_product_inventariable">{{
                  $t("is inventariable")
                }}</label>
              </div>
            </div>
            <div class="column is-5">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_product_available_for_purchase"
                  v-model="meta.available_for_purchase"
                />
                <label for="chk_product_available_for_purchase">{{
                  $t("available for purchase")
                }}</label>
              </div>
            </div>
            <div class="column is-5">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_product_is_combo"
                  v-model="meta.is_combo"
                />
                <label for="chk_product_is_combo">{{
                  $t("is combo product")
                }}</label>
              </div>
            </div>
          </div>

          <div v-if="meta.is_combo">
            <div class="title is-6 mt-5 mb-3">
              {{ $t("products in combo") }}
            </div>
            <div class="columns">
              <div class="column is-2">
                <div class="field">
                  <label class="label">{{ $t("quantity") }}</label>
                  <input
                    class="input"
                    type="number"
                    v-model.number="combo.quantity"
                  />
                </div>
              </div>
              <div class="column is-5">
                <div class="field">
                  <generic-dropdown
                    :title="$t('meassurement')"
                    :placeholder="$t('select')"
                    url="/product/meassurement-unit/catalog"
                    name_field="name"
                    value_field="unit_id"
                    :is_multiple="false"
                    @selected="set_combo_meassurement"
                    ref="combo_meassurement_dropdown"
                  />
                </div>
              </div>
              <div class="column is-5">
                <div class="field">
                  <generic-dropdown
                    :title="$t('product')"
                    :placeholder="$t('select')"
                    url="/product/catalog"
                    name_field="name"
                    value_field="product_id"
                    :is_multiple="false"
                    @selected="set_combo_product"
                    ref="combo_product_dropdown"
                  />
                </div>
              </div>

              <div class="column is-1">
                <div class="field">
                  <label class="label">&nbsp;</label>
                  <button
                    class="button is-success is-rounded"
                    :disabled="
                      !combo.product_id || !combo.quantity || !combo.unit_id
                    "
                    @click.prevent="add_combo_product"
                  >
                    <span class="icon"><i class="fa fa-plus"></i></span>
                    <!-- <span>{{ $t("add") }}</span> -->
                  </button>
                </div>
              </div>
            </div>
            <div class="table-container">
              <table class="table is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>{{ $t("quantity") }}</th>
                    <th>{{ $t("meassurement") }}</th>
                    <th>{{ $t("product") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody v-if="meta.combo_products">
                  <tr
                    v-for="(combo_product, cidx) in meta.combo_products"
                    :key="cidx"
                  >
                    <td>{{ combo_product.quantity }}</td>
                    <td>{{ combo_product.unit_name }}</td>
                    <td>{{ combo_product.product_name }}</td>
                    <td>
                      <button
                        class="button is-danger is-small"
                        @click.prevent="meta.combo_products.splice(cidx, 1)"
                      >
                        <span class="icon"><i class="fa fa-trash"></i></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
      <div class="is-hidden" data-tab="images">
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="generic_uploader"
              :idle_label="$t('drop product images here')"
              endpoint_url="/product/image"
              :extra_data="{ product_uuid: meta.uuid }"
              :allow_multiple="true"
              @error="error_uploading"
              @success="success_uploading"
            />
          </div>
        </div>
        <div class="grid is-col-min-7">
          <div
            v-if="meta && meta.settings && meta.settings.images"
            class="cell"
            v-for="(photo, midx) in meta.settings.images"
            :key="midx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <p class="subtitle is-7 has-text-centered"></p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="meta.settings.images.splice(midx, 1)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
      <div class="is-hidden" data-tab="attributes">
        <attributes ref="attributes" />
        <!-- <div class="box mt-0">
          <div class="columns">
            <div class="column">
              <p class="buttons is-pulled-right">
                <button
                  class="button is-secondary is-rounded"
                  @click="meta.settings.attributes.push({})"
                >
                  <span class="icon"><i class="fa fa-plus"></i></span>
                  <span>{{ $t("add") }}</span>
                </button>
              </p>
            </div>
          </div>
          <div class="table-container" ref="tc">
            <table
              class="table is-striped is-hoverable"
              ref="table"
              style="width: 100%"
            >
              <thead>
                <tr>
                  <th>{{ $t("attribute") }}</th>
                  <th>{{ $t("options") }}</th>
                </tr>
              </thead>
              <tbody v-if="meta.settings && meta.settings.attributes">
                <tr
                  v-for="(custom_attribute, pidx) in meta.settings.attributes"
                  :key="pidx"
                >
                  <td>
                    {{ custom_attribute.name }}
                  </td>
                  <td>
                    <p class="buttons">
                      <a
                        class="button"
                        :data-tooltip="$t('configure')"
                        @click="configure_attribute(custom_attribute)"
                      >
                        <span class="icon has-text-info">
                          <i class="fa fa-cogs"></i>
                        </span>
                      </a>
                      <a
                        class="button"
                        :data-tooltip="$t('delete')"
                        @click="meta.custom_attributes.splice(pidx, 1)"
                      >
                        <span class="icon has-text-danger">
                          <i class="fa fa-trash"></i>
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>
        </div> -->
        <!-- <form v-if="meta.settings && meta.settings.attributes">
          <div class="field" v-for="(attr, aidx) in meta.settings.attributes">
            <label class="label">{{ attr.name }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.attributes[aidx].value"
              />
            </div>
          </div>
        </form> -->
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import VLazyImage from "v-lazy-image";
import Attributes from "./Attributes.vue";

export default {
  name: "CreateProductModal",
  components: {
    GenericModal,
    GenericUploader,
    VLazyImage,
    GenericDropdown,
    Attributes,
  },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      combo: {
        quantity: 1,
        product_id: "",
        product_name: "",
        unit_id: "",
        unit_name: "",
      },
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(product_uuid) {
      let v = this;
      v.set_initial_state();

      if (product_uuid) {
        // v.uuid = product_uuid;
        get("/product", { uuid: product_uuid })
          .then((product) => {
            v.meta = product;
            if (v.meta.settings.attributes)
              v.$refs.attributes.set_attributes(v.meta.settings.attributes);

            if (product.product_category_suscriptions) {
              v.meta.categories = product.product_category_suscriptions.map(
                (category) => category.category_id
              );
              v.$refs.category_dropdown.set_value(v.meta.categories);
            }

            v.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        v.$refs.generic_modal.show_modal();
        // v.meta.settings.attributes = JSON.parse(
        //   JSON.stringify(v.module_settings.custom_attributes)
        // );
      }
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.settings.attributes = v.$refs.attributes.get_attributes();
      v.$root.loader(true);
      if (!v.meta.uuid)
        put("/product", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      else
        post("/product", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        barcode: "",
        sale_price: "",
        categories: [],
        settings: { attributes: [] },
      };
      v.error = "";
      v.$refs.generic_uploader.clear();
      v.$refs.category_dropdown.clear();
      v.$refs.attributes.set_initial_state();
      // v.uuid = "";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
        meta: rspnse.file.settings,
        original_name: rspnse.file.name,
      };
      if (v.meta.settings.images) {
        v.meta.settings.images.push(data);
      } else {
        v.meta.settings.images = [data];
      }
    },
    set_category(categories) {
      let v = this;
      v.meta.categories = categories;
    },
    set_combo_product(product) {
      let v = this;
      if (product) {
        v.combo.product_id = product.product_id;
        v.combo.product_name = product.name;
      } else {
        v.combo.product_id = "";
        v.combo.product_name = "";
      }
    },
    add_combo_product() {
      let v = this;
      if (v.meta.combo_products) {
        v.meta.combo_products.push({ ...v.combo });
      } else {
        v.meta.combo_products = [{ ...v.combo }];
      }
      v.combo.quantity = 1;
      v.combo.product_id = "";
      v.combo.product_name = "";
      v.combo.unit_id = "";
      v.combo.unit_name = "";
      v.$refs.combo_product_dropdown.clear();
      v.$refs.combo_meassurement_dropdown.clear();
    },
    set_combo_meassurement(meassurement) {
      let v = this;
      if (meassurement) {
        v.combo.unit_id = meassurement.unit_id;
        v.combo.unit_name = meassurement.name;
      } else {
        v.combo.unit_id = "";
        v.combo.unit_name = "";
      }
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
